import { Link } from 'react-router-dom';
import { useT } from '../i18n/index.ts';

/**
 * Shown for any unmatched path inside the authenticated shell. Keeps
 * the tenant oriented by linking back to the dashboard; `surface-
 * container` card preserves the design density.
 */
export function NotFound(): JSX.Element {
  const t = useT();
  return (
    <section
      data-testid="not-found-page"
      className="flex min-h-[60vh] flex-col items-center justify-center gap-4 rounded-xl bg-surface-container px-8 py-16 text-center"
    >
      <span
        aria-hidden="true"
        className="material-symbols-outlined text-[48px] text-outline"
      >
        help
      </span>
      <h2 className="text-3xl font-semibold tracking-tight text-on-surface">
        {t('notfound.title')}
      </h2>
      <p className="max-w-md text-sm text-outline">{t('notfound.body')}</p>
      <Link
        to="/dashboard"
        className="inline-flex items-center justify-center rounded-xl bg-primary-container px-6 py-3 text-xs font-bold uppercase tracking-[0.08em] text-on-primary transition-all hover:shadow-[0_0_16px_rgba(173,198,255,0.2)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-surface-container"
      >
        {t('notfound.cta')}
      </Link>
    </section>
  );
}
